export default "__VITE_ASSET__DCruLOfd__"